import "./exhibition_group_page.scss"

